/* Registre des cibles du Guide : une clé stable → un sélecteur de l'interface
   réelle. Les clés vivent dans data/onboarding.js ; les sélecteurs, ici.

   Deux autres formes sont admises sans passer par le registre :
   - `tab:<id>`  → l'onglet <id> de la ligne d'onglets de la page (Tabs pose
                   `data-tab` sur chaque onglet) ;
   - toute autre clé → l'élément qui porte `data-tour="<clé>"` dans l'écran.
   Un écran qui veut se laisser guider pose donc un `data-tour` sur ce qu'il
   montre, sans toucher à ce fichier. */
const TARGETS = {
  modules: '.sb-topmods',
  'band-rh': '[data-tour="band-rh"]',
  'band-knowledge': '[data-tour="band-knowledge"]',
  client: '.app-tenant',
  year: '.app-topbar__right',
  export: '.app-export',
  settings: '.app-topbar__icon',
  tabs: '.tabs',
  'panel-pin': '.sb-panel-fold',
  logout: '[data-tour="logout"]',
  'guide-button': '[data-tour="guide-button"]',
  'page-title': '[data-tour="page-title"]',
};

export function selectorFor(key) {
  if (!key) return null;
  if (TARGETS[key]) return TARGETS[key];
  if (key.startsWith('tab:')) return `.tabs__tab[data-tab="${key.slice(4)}"]`;
  return `[data-tour="${key}"]`;
}

export function findTarget(key) {
  const sel = selectorFor(key);
  return sel ? document.querySelector(sel) : null;
}

export default TARGETS;
